/**
 * Permission codes for the Reporting Suite.
 *
 * Standard and custom reports each carry a Run permission keyed by the
 * report's catalog code (`Report.<code>.Run`), so those are matched by
 * pattern rather than listed. The custom report builder and the downloads
 * page have fixed codes.
 */
export const CUSTOM_REPORT_PERMISSIONS = {
  view: 'CustomReport.View',
  create: 'CustomReport.Create',
  edit: 'CustomReport.Edit',
  delete: 'CustomReport.Delete',
} as const;

/** Any of these opens the Build Custom Report area. */
export const CUSTOM_REPORT_ANY_PERMISSION: string[] = Object.values(
  CUSTOM_REPORT_PERMISSIONS
);

export const DOWNLOADED_REPORTS_PERMISSIONS = {
  viewSelf: 'Report.Downloads.ViewSelf',
  viewAll: 'Report.Downloads.ViewAll',
} as const;

/** Either downloads scope opens the Downloaded Reports page. */
export const DOWNLOADED_REPORTS_ANY_PERMISSION: string[] = Object.values(
  DOWNLOADED_REPORTS_PERMISSIONS
);

/**
 * Matches any report's Run code. Kept as a string so the sidebar config
 * (JSON) can carry the same pattern.
 */
export const REPORT_RUN_PERMISSION_PATTERN = String.raw`^Report\.[^.]+\.Run$`;

/** The Run permission code for one report, by its catalog code. */
export const getReportRunPermission = (reportCode: string): string =>
  `Report.${reportCode}.Run`;

/** True when any of the codes matches the (regex) pattern. */
export const matchesPermissionPattern = (
  codes: string[],
  pattern: string
): boolean => {
  const regex = new RegExp(pattern);
  return codes.some(code => regex.test(code));
};
